module.exports = __webpack_public_path__ + "static/img/promotions.ce1bfa8.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_icons/promotions.jpeg
// module id = TVA/
// module chunks = 4